import WebUtils from "../utils/WebUtils";

let baseUrl = WebUtils.getProctorBaseUrl();
let proctorPlatformBaseUrl = `${baseUrl}/proctor-platform/api/v1`;

export const signupApi = `${proctorPlatformBaseUrl}/registration/createAccount`;
export const verifyEmailApi = `${proctorPlatformBaseUrl}/registration/verifyAccount`;
export const resendVerifyEmailApi = `${proctorPlatformBaseUrl}/registration/resendAccountActivationLink`;
export const loginApi = `${proctorPlatformBaseUrl}/login/`;
export const resetPasswordPostApi = `${proctorPlatformBaseUrl}/registration/resetPassword/sendLink`;
export const validateResetPassGetApi = `${proctorPlatformBaseUrl}/registration/resetPassword/validate`;
export const newPassSetPostApi = `${proctorPlatformBaseUrl}/registration/resetPassword`;
export const forcePassSet = `${proctorPlatformBaseUrl}/account/auth/setPassword`;
export const getOnBoardingStatusApi = `${proctorPlatformBaseUrl}/account/getOnBoardingStatus`;

export const getProfileInfoApi = `${proctorPlatformBaseUrl}/account/getProfileInfo`;
export const refreshTokenApi = `${proctorPlatformBaseUrl}/login/refresh`;
export const updateProfileInfoApi = `${proctorPlatformBaseUrl}/account/updateProfileInfo`;

